function listarAnosDe2010AteAtual() {
    const anoAtual = new Date().getFullYear();
    const anos = [];

    for (let ano = anoAtual; ano >= 2010; ano--) {
        anos.push({ anoBike: ano });
    }

    return anos;
}

// Exemplo de uso
const listaAnos = listarAnosDe2010AteAtual();

// Exportando o array atualizado
export default listaAnos;